<template>
    <div class="d-md-flex align-items-center justify-content-between mb-2 mt-2">
        <div>
            <h4 class="main-title mb-0">Property Disposal Stages</h4>
        </div>
    </div>
    <div class="row g-3 mb-2">
        <div class="col-xl-4">
            <form class="card card-one" @submit.prevent="submitForm()">
                <div class="card-header">
                    <h6 class="card-title" v-if="status">New Property Disposal Stage </h6>
                    <h6 class="card-title" v-else>Update Property Disposal Stage </h6>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12">
                            <label class="form-label">Property Disposal Stage</label><span class="text-danger"> *</span>
                            <input type="text" class="form-control" placeholder="Property Disposal Stage" :class="{'is-invalid': errors.property_disposal_stage}" v-model="property_disposal_stage.property_disposal_stage" ref="property_disposal_stage" />
                            <span v-if="errors.property_disposal_stage" class="invalid-feedback">{{ errors.property_disposal_stage[0] }}</span>
                        </div>
                    </div>
                    
                </div>
                <div class="card-footer text-end">
                    <button class="btn btn-danger me-2" type="button" @click="discard()"> <i class="ri-prohibited-line me-1"></i>Discard</button>
                    <button class="btn btn-primary " type="submit">
                        <span v-if="status"> <i class="ri-save-line me-1"></i> Submit</span>
                        <span v-else> <i class="ri-save-line me-1"></i> Update </span>
                    </button>
                </div>
            </form>
        </div>
        <div class="col-xl-8">
            <div class="card card-one">
                <div class="card-header">
                    <h6 class="card-title">Property Disposal Stage</h6>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <input type="text" class="form-control mb-2" id="search" placeholder="Search" v-model="meta.search" @keypress.enter="search()">
                    </div>
                    <div class="table-responsive">
                        <table class="table table-striped text-nowrap table-bordered table-hover table-bottom-border mb-0">
                            <thead>
                                <tr style="background-color: #f5f5f5;">
                                    <th class="text-center">Sl No.</th>
                                    <th @click="sort('property_disposal_stage')">
                                        Property Disposal Stage
                                        <span>
                                            <i v-if="meta.keyword=='property_disposal_stage' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                            <i v-else-if="meta.keyword=='property_disposal_stage' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                            <i v-else class="fas fa-sort"></i>
                                        </span>
                                    </th>
                                    <th class="text-center">Status</th>
                                    <th class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="property_disposal_stage, key in property_disposal_stages" :key="key">
                                    <td class="text-center">{{ meta.from + key }}</td>
                                    <td>{{property_disposal_stage.property_disposal_stage}}</td>

                                    <td class="text-center">
                                        <div class="form-switch">
                                            <input class="form-check-input" type="checkbox" role="switch" :id="'property_disposal_stage' + property_disposal_stage.property_disposal_stage_id" :checked="property_disposal_stage.status" :value="property_disposal_stage.status" @change="deletePropertyDisposalStage(property_disposal_stage)" />
                                            <label class="custom-control-label" :for="'property_disposal_stage' + property_disposal_stage.property_disposal_stage_id"></label>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <nav v-if="property_disposal_stage.status">
                                            <a href="javascript:void(0)" class="text-primary me-2" @click="edit(property_disposal_stage)"><i class="ri-edit-line fs-18 lh-1"></i></a>
                                        </nav>
                                    </td>
                                </tr>
                                <tr v-if="property_disposal_stages.length <= 0">
                                    <td colspan="4" style="text-align: center;">No Records Found</td>
                                </tr>
                           
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card-footer">
                    <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                </div>
            </div>
        </div>
       
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    export default {
        components: {
            Pagination,
        },
        data() {
            return {
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "property_disposal_stage_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    maxPage: 1,
                },
                property_disposal_stage:{
                    property_disposal_stage_id:"",
                    property_disposal_stage:""
                },
                property_disposal_stages:[],
                status:true,
                errors: [],
            };
        },
        mounted() {
            let vm = this;
            vm.$refs.property_disposal_stage.focus();
            vm.index();
        },

        methods: {
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.create();
                } else {
                    vm.update();
                }
            },
            index() {
                let vm = this;
                vm.$store.dispatch("post", { uri: "paginatePropertyDisposalStages", data: vm.meta })
                .then(function (response) {
                    vm.property_disposal_stages = response.data.data;
                    vm.meta.totalRows = response.data.meta.total;
                    vm.meta.lastPage = response.data.meta.last_page;
                    vm.meta.from = response.data.meta.from;
                    vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                })
                .catch(function (error) {
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },
            create(){
                let vm = this;
                let loader = vm.$loading.show();
                let uri = { uri: "addPropertyDisposalStage", data: vm.property_disposal_stage };
                vm.$store.dispatch("post", uri)
                .then(function () {
                    loader.hide();
                    vm.$store.dispatch("success", "Property Disposal Stage is successfully created");
                    vm.discard();
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },
            edit(property_disposal_stage){
                let vm = this;
                vm.property_disposal_stage = property_disposal_stage;
                vm.status = false;
                vm.$refs.property_disposal_stage.focus();
            },
            update(){
                let vm = this;
                let loader = vm.$loading.show();
                let uri = { uri: "updatePropertyDisposalStage", data: vm.property_disposal_stage };
                vm.$store
                    .dispatch("post", uri)
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "Property Disposal Stage is successfully updated");
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            deletePropertyDisposalStage(property_disposal_stage){
                let vm = this;
                let loader = vm.$loading.show();
                let uri = { uri: "deletePropertyDisposalStage", data: property_disposal_stage };
                vm.$store
                    .dispatch("post", uri)
                    .then(function (response) {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            discard() {
                let vm = this;
                vm.property_disposal_stage.property_disposal_stage = "";
                vm.property_disposal_stage.property_disposal_stage_id = "";
                vm.errors = [];
                vm.status = true;
                vm.$refs.property_disposal_stage.focus();
                vm.index();
            },
            onPageChange(page) {
                this.meta.page = page;
                this.index();
            },
            search(){
               let vm = this;
               vm.meta.page = 1;
               vm.index();
            },
            sort(field) {
                this.meta.keyword = field;
                this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
                this.index();
            },
        },
    };
</script>
<style scoped>
 input:focus,
    select:focus {
        outline: none;
        box-shadow: 0 0 0 0 transparent;
    }
</style>